import type { DataAction } from '../../../types/dataAction.type';

export const UPDATE_CAMPAIGN_FILTER = 'UPDATE_CAMPAIGN_FILTER' as const;

export const updateCampaignFilter = (campaign: string[]) => ({ data: { campaign }, type: UPDATE_CAMPAIGN_FILTER });

export type UpdateCampaignFilterResponseAction = DataAction<typeof UPDATE_CAMPAIGN_FILTER, { campaign: string[] }>;
